const escapeHtml = (value = "") =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const formatInlineMarkdown = (value = "") => {
  let formatted = escapeHtml(value);

  formatted = formatted.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, (_match, text, url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-theme underline break-words">${text}</a>`;
  });
  formatted = formatted.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  formatted = formatted.replace(/\*(.+?)\*/g, "<em>$1</em>");
  formatted = formatted.replace(/`([^`]+)`/g, "<code class=\"rounded bg-black/5 px-1 py-0.5 text-[0.95em] dark:bg-white/10\">$1</code>");

  return formatted;
};

export const renderMarkdownToHtml = (markdownContent = "") => {
  const normalizedContent = markdownContent
    .replace(/\r\n/g, "\n")
    .replace(/\s(#{1,6}\s)/g, "\n$1")
    .replace(/\s(\*\s)/g, "\n$1")
    .replace(/\s(---+)/g, "\n$1")
    .trim();

  if (!normalizedContent) {
    return "";
  }

  const lines = normalizedContent.split("\n");
  const blocks = [];
  let currentParagraph = [];
  let currentList = [];

  const flushParagraph = () => {
    if (!currentParagraph.length) {
      return;
    }

    blocks.push(`<p>${formatInlineMarkdown(currentParagraph.join(" "))}</p>`);
    currentParagraph = [];
  };

  const flushList = () => {
    if (!currentList.length) {
      return;
    }

    const listItems = currentList
      .map((item) => `<li>${formatInlineMarkdown(item)}</li>`)
      .join("");
    blocks.push(`<ul>${listItems}</ul>`);
    currentList = [];
  };

  lines.forEach((line) => {
    const trimmedLine = line.trim();

    if (!trimmedLine) {
      flushParagraph();
      flushList();
      return;
    }

    if (/^---+$/.test(trimmedLine)) {
      flushParagraph();
      flushList();
      blocks.push("<hr />");
      return;
    }

    const headingMatch = trimmedLine.match(/^(#{1,6})\s+(.*)$/);
    if (headingMatch) {
      flushParagraph();
      flushList();
      const level = headingMatch[1].length;
      blocks.push(`<h${level}>${formatInlineMarkdown(headingMatch[2])}</h${level}>`);
      return;
    }

    const listMatch = trimmedLine.match(/^[-*]\s+(.*)$/);
    if (listMatch) {
      flushParagraph();
      currentList.push(listMatch[1]);
      return;
    }

    flushList();
    currentParagraph.push(trimmedLine);
  });

  flushParagraph();
  flushList();

  return blocks.join("");
};
